import { CommonModule } from "@angular/common";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { CommissionService } from "src/app/iap/services/commission.service";

@Component({
    selector: "app-view-submitted-original",
    templateUrl: "./view-submitted.component.html",
    styleUrls: ["./view-submitted.component.scss"],
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        CommonModule,
        MatIconModule
    ]
})
export class ViewSubmittedOriginalComponent implements OnInit {
  @Output() rowClickedEvent = new EventEmitter<boolean>();

  public applicationID: string;
  public agencyID: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commissionService: CommissionService
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.applicationID = params["id"];
      this.agencyID = params["agencyID"];
    });
  }

  onCancel(): void {
    this.rowClickedEvent.emit(false);
  }
}
